import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import {
  loadGeneralSettings,
  shouldLoadGeneralSettings,
} from 'redux/reducers/generalSettings';

function mapStateToProps(state) {
  const { generalSettings } = state;
  return { generalSettings };
}

export function withGeneralSettings(WrappedComponent) {
  return compose(
    connect(mapStateToProps, {
      shouldLoadGeneralSettings,
      loadGeneralSettings,
    }),
    lifecycle({
      componentDidMount() {
        if (this.props.shouldLoadGeneralSettings()) {
          this.props.loadGeneralSettings();
        }
      },
    })
  )(WrappedComponent);
}
